import api from '../../api'

const comm = {
    state: {
        knowlegeUrl:'list_KNOWLEGE_1_1.html',
        cptListIndex:'list_PC_PRODUCT_1_1.html',
        ssdProIndex:'list_SSD_PRODUCT_1_1.html'
    },
    mutations: {
        SET_URL: (state, item) => {
            state.knowlegeUrl = item.knowlegeUrl ? item.knowlegeUrl:state.knowlegeUrl
            state.cptListIndex = item.cptListIndex ? item.cptListIndex:state.cptListIndex
            state.ssdProIndex = item.ssdProIndex ? item.ssdProIndex:state.ssdProIndex
        },

    },
    actions: {
        getUrl({commit, state}) {
            return new Promise((resolve, reject) => {
                api.Get('/home/url', {}, (result)=>{
                    if(result.isSuccess) {
                        resolve(result)
                    } else {
                        reject(error)
                    }
                })
            }).catch(error => {
               console.log(error)
            })
        },
    }
}
export default comm



